import { TipoPagamento } from "@/components/vitrine/data/tipoPagamento"
import { priceFormatter } from "@/utils/formatter"
import { Device }from "@/utils/device"
import type { BannerCarrosselProps } from "../../banner-carrossel.props"

interface ValorProdutoProps {
    banner: BannerCarrosselProps
    precoPrincipal: TipoPagamento
    condicaoParcelamento: number
    device: number
}

export const ValorProduto = ({
    banner,
    precoPrincipal,
    condicaoParcelamento,
    device
}: ValorProdutoProps) => {
    let parcelasCartao: number | undefined
    let precoCartao: number | undefined
    let precoProduto = banner.valor_boleto
    const isMobileOrApp = [Device.MOBILE, Device.APP].includes(device)
    let precoCondicao = isMobileOrApp ? "no boleto" : "no boleto bancário"

    if (banner.valor_cartao) {
        parcelasCartao = banner.valor_cartao[0]
        precoCartao = precoPrincipal === TipoPagamento.CARTAO ? banner.valor_cartao[1] : banner.valor_cartao[2]

        if (condicaoParcelamento === TipoPagamento.CARTAO) {
            parcelasCartao = banner.valor_cartao[5]?.parcelas
            precoCartao = precoPrincipal === TipoPagamento.CARTAO ? banner.valor_cartao[5]?.valor : banner.valor_cartao[5]?.valorParcela
        } else if (condicaoParcelamento === 1) {
            parcelasCartao = 1
            precoCartao = banner.valor_cartao[5]?.valor
        }
    }

    if (precoPrincipal === TipoPagamento.PIX && banner.valor_pix) {
        precoProduto = banner.valor_pix
        precoCondicao = "no PIX"
    }

    if (banner.valor_cartao && precoPrincipal === TipoPagamento.CARTAO) {
        return (
            <>
                <div className="valor-produto">
                    <div className="valor">{priceFormatter.format(precoCartao!)}</div>
                    <div className="condicao">
                        em até {parcelasCartao}x no cartão {condicaoParcelamento === 2 ? " s/ juros" : ""}
                    </div>
                </div>
                <div className="valor-produto-cartao">
                    <div className="valor-cartao">ou {priceFormatter.format(precoProduto)} {precoCondicao}</div>
                </div>
            </>
        )
    }
}